module.exports = __webpack_public_path__ + "static/media/alert_circle.e9c8e3fb.svg";